import { CreateSqlEngineInputWorkerSizeEnum } from '@repo/api-gw-sdk';

export interface CreateSqlEngineWizardState {
  workspaceId: string;
  name: string;
  workerSize: CreateSqlEngineInputWorkerSizeEnum;
  autoscaling: boolean;
  workerCount: number;
  minWorkers: number;
  maxWorkers: number;
  idleTimeoutEnabled: boolean;
  idleTimeoutMinutes: number;
  iamRoleArn: string;
}

export const defaultCreateSqlEngineWizardState: CreateSqlEngineWizardState = {
  workspaceId: '',
  name: '',
  workerSize: CreateSqlEngineInputWorkerSizeEnum.Small,
  autoscaling: false,
  workerCount: 1,
  minWorkers: 1,
  maxWorkers: 3,
  idleTimeoutEnabled: true,
  idleTimeoutMinutes: 10,
  iamRoleArn: '',
};
